import { Link } from "react-router-dom";
import { MoveUpRight } from "lucide-react";
import { SERVICES } from "../data/content";
import { MaskedLines, Reveal } from "../components/Motion";
import { BookingButton, CtaBand, InquiryButton } from "../components/Cta";

export default function Services() {
  return (
    <>
      <section className="page-hero simple" data-testid="services-hero">
        <div className="ph-content">
          <p className="crumb">
            <Link to="/">Home</Link> <span>/</span> Services
          </p>
          <h1>
            <MaskedLines lines={[<>Six crafts.</>, <em key="o">One standard.</em>]} delay={0.2} />
          </h1>
          <p className="ph-intro">
            Everything a brand needs to be seen, remembered and bought from — under one roof, held to one bar. Pick a
            craft, or hand us the whole build.
          </p>
        </div>
      </section>

      <section className="services-index section-pad" data-testid="services-index">
        <div className="service-list">
          {SERVICES.map((service, index) => (
            <Reveal key={service.slug} delay={index * 0.05}>
              <Link to={`/services/${service.slug}`} className="svc-row" data-testid={`services-row-${service.slug}`}>
                <span className="service-number">0{index + 1}</span>
                <span className="svc-main">
                  <h3>{service.name}</h3>
                  <em>{service.tagline}</em>
                </span>
                <span className="svc-desc">{service.intro}</span>
                <MoveUpRight size={22} />
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="unsure section-pad" data-testid="services-unsure">
        <Reveal>
          <p className="eyebrow">Not sure where to start?</p>
          <h2>
            Tell us the problem.
            <br />
            <em>We&apos;ll bring the craft.</em>
          </h2>
          <p className="unsure-copy">
            Most engagements touch more than one discipline. Send a rough brief or grab twenty minutes with the studio —
            we&apos;ll shape the right mix together.
          </p>
          <div className="contact-actions row">
            <InquiryButton label="Send a rough brief" testid="services-unsure-inquiry-button" />
            <BookingButton testid="services-unsure-booking-button" />
          </div>
        </Reveal>
      </section>

      <CtaBand testid="services-cta-band" />
    </>
  );
}
